import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=25b9215a"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25b9215a')) {
      api.createRecord('25b9215a', component.options)
    } else {
      api.reload('25b9215a', component.options)
    }
    module.hot.accept("./Profile.vue?vue&type=template&id=25b9215a", function () {
      api.rerender('25b9215a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Profile.vue"
export default component.exports